import { defineStore } from 'pinia'
import { USER_STORE_ID } from '../constants'
import type { AuthUser } from '../entities/AuthUser'

export const useUserStore = defineStore({
  id: USER_STORE_ID,
  state: (): AuthUser<any> => {
    return {
      logged: undefined,
      avatar: undefined,
      name: undefined,
      mail: undefined,
      id: undefined,
      type: undefined,
      params: undefined,
    }
  },
  getters: {
    getLogged: state => state.logged,
    getUserdata: (state): AuthUser<any> => ({
      logged: state.logged,
      avatar: state.avatar,
      name: state.name,
      mail: state.mail,
      id: state.id,
      type: state.type,
      params: state.params,
    }),
    getUserId: state => state.id,
  },
  actions: {
    setUser(user: AuthUser<any>) {
      this.logged = user.logged
      this.avatar = user.avatar
      this.name = user.name
      this.mail = user.mail
      this.id = user.id
      this.type = user.type
      this.params = user.params
    },
  },
})
